import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { globalVariables } from "helper/globalVariables";
import { useLazyQuery } from "@apollo/client";
import {
  getAllAwardsQuery,
  getAllTrialResultUniqueElementsQuery,
  getTrialCalendarByIdQuery,
  getTrialResultByInElementOrderQuery,
} from "redux/features/trailResultSlice/trailResultGql";
import Loader from "shared/Components/loader";
import moment from "moment";
import Modal from "shared/Components/modal";
import { TrialResultDetailCard } from "./TrialResultDetailCard";
import { ResultDetailCard } from "./ResultDetailCard";
import MultiSelectWithSearch from "shared/Components/multiSelectWithSearch";
import PageInfo from "shared/Components/pageInfo";
import { useNavigate } from "react-router-dom";
import { dog as dogImg } from "helper/images";
import Table from "container/MemberDashboard/Components";
import { globalClasses } from "helper/globalClasses";
import { orderSearchesElements } from "helper/orderSearchElements";
import ScrollToTop from "shared/Components/scrollToTop";

const TrialResultDetails = ({ trialData, setTrial, isUpload, isMember }) => {
  function extractIdFromCurrentUrl() {
    try {
      // Use window.location to get the current URL
      const url = window.location.href;
      // Extract the pathname, split it, and get the last part
      const parts = url.split("/").filter((part) => part !== "");
      const id = parts[parts.length - 1];
      // Attempt to convert the last part to an integer
      const parsedId = parseInt(id, 10);
      if (isNaN(parsedId)) {
        throw new Error("The current URL does not end with an integer ID.");
      }
      return parsedId;
    } catch (error) {
      console.error("Error extracting ID from the current URL:", error);
      // Handle error or invalid URL structure as needed
      return null; // or throw error;
    }
  }

  const { tableDataCls } = globalClasses;

  const id = extractIdFromCurrentUrl();
  // const id = trialData?.id;

  console.log("Trial ID trialData", trialData);

  const isSmallMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 630px)" });

  const [selectedTrialData, setSelectedTrialData] = useState(null);
  const [selectedElements, setSelectedElements] = useState([]);
  const [tableResult, setTableResult] = useState([]);
  const navigate = useNavigate();

  const [
    getAllTrialResultUniqueElements,
    { data: allTrialResultUniqueElements },
  ] = useLazyQuery(getAllTrialResultUniqueElementsQuery);

  const [getAllAwards, { data: allAwards }] = useLazyQuery(getAllAwardsQuery, {
    fetchPolicy: "network-only",
  });

  const [getTrialCalendarById, { data: trialCalendarById, loading, error }] =
    useLazyQuery(getTrialCalendarByIdQuery, {
      fetchPolicy: "network-only",
    });
  const { trail, host, judgeName } =
    trialCalendarById?.getTrialCalendarById || {};

  const [
    getTrialResultByInElementOrder,
    { data: trialResultByInElementOrder, loading: resultLoading },
  ] = useLazyQuery(getTrialResultByInElementOrderQuery, {
    fetchPolicy: "network-only",
  });

  const mooTipsAward = allAwards?.getAllAwards?.find((item) => item.award == "Moo Tips Award");

  const otherAwards = allAwards?.getAllAwards?.filter((item) => item.award !== "Moo Tips Award");

  const sortedAwards = mooTipsAward ? [mooTipsAward, ...otherAwards] : otherAwards;

  const premierPlacementResults = tableResult.filter(e => e.title.includes("Place Overall"));

  const noPlacementResults = tableResult.filter(e => !e.title.includes("Place Overall"));

  const noPlacementDropdowns = allTrialResultUniqueElements?.getAllTrialResultUniqueElements.filter(e => !e.includes("Place Overall"));
  useEffect(() => {
    const saveTable = [];

    for (
      let index = 0;
      index <
      trialResultByInElementOrder?.getTrialResultByInElementOrder?.length;
      index++
    ) {
      const e =
        trialResultByInElementOrder?.getTrialResultByInElementOrder?.[index];

      if (selectedElements.length) {
        if (selectedElements.includes(e?.searchName)) {
          if (!e?.searchName.includes("SIT")) {
            saveTable.push({
              title: e?.searchName,
              tableHeading: [
                "Handler",
                "Dog",
                "Breed",
                "Div",
                "Q",
                "Points",
                "Time",
                "Place",
                "Div",
              ],
              values: e?.results,
            });
          } else {
            saveTable.push({
              title: e?.searchName,
              tableHeading: ["Handler", "Dog", "Breed", "Odor", "Q", "Time"],
              values: e?.results,
            });
          }
        }
      } else {
        if (!e?.searchName.includes("SIT")) {
          saveTable.push({
            title: e?.searchName,
            tableHeading: [
              "Handler",
              "Dog",
              "Breed",
              "Div",
              "Q/NQ",
              "Time",
              "Points",          
              "Place",      
            ],
            values: e?.results,
          });
        } else {
          saveTable.push({
            title: e?.searchName,
            tableHeading: ["Handler", "Dog", "Breed", "Div", "Q/NQ", "Odor", "Time"],
            values: e?.results,
          });
        }
      }
    }

    setTableResult(saveTable);
  }, [
    trialResultByInElementOrder?.getTrialResultByInElementOrder?.length,
    trialResultByInElementOrder?.getTrialResultByInElementOrder,
    selectedElements.length,
    selectedElements,
  ]);

  const tableModalRef = useRef();

  useEffect(() => {
    getAllTrialResultUniqueElements({
      variables: {
        // trialCalendarId: 2,
        trialCalendarId: parseInt(id),
      },
    });
    getAllAwards({
      variables: {
        // trialCalendarId: 2,
        trialCalendarId: parseInt(id),
      },
    });
    getTrialCalendarById({
      variables: {
        // trialCalendarId: 2,
        trialCalendarId: parseInt(id),
      },
    });
    getTrialResultByInElementOrder({
      variables: {
        // trialCalendarId: 2,
        trialCalendarId: parseInt(id),
      },
    });
  }, []);

  const getValue = (value) => {
    return value || "N/A";
  };
    
  const renderTableBody = (tableRes) => {
    return tableRes?.map((data) => (
      <tr key={data.id}>
        <td className={tableDataCls}>{getValue(data?.handler)}</td>
        <td className={tableDataCls}>{getValue(data?.dog)}</td>
        <td className={tableDataCls}>{getValue(data?.breed)}</td>
        <td className={tableDataCls}>{getValue(data?.div)}</td>
        <td className={tableDataCls}>{getValue(data?.qNq)}</td>
        <td className={tableDataCls}>{getValue(data?.time)}</td>
        <td className={tableDataCls}>{getValue(data?.points)}</td>
        <td className={tableDataCls}>{getValue(data?.place)}</td>
      </tr>
    ));
  };

  const renderTableBodyForSIT = (tableRes) => {
    return tableRes?.map((data) => (
      <tr key={data.id}>
        <td className={tableDataCls}>{getValue(data?.handler)}</td>
        <td className={tableDataCls}>{getValue(data?.dog)}</td>
        <td className={tableDataCls}>{getValue(data?.breed)}</td>
        <td className={tableDataCls}>{getValue(data?.div)}</td>
        <td className={tableDataCls}>{getValue(data?.qNq)}</td>
        <td className={tableDataCls}>{getValue(data?.odor)}</td>
        <td className={tableDataCls}>{getValue(data?.time)}</td>
      </tr>
    ));
  };

  const openModal = (data) => {
    setSelectedTrialData(data);
    tableModalRef.current.openModal();
  };

  const renderCard = (data) => {
    const { dog, handler, breed, award, dogImage, color, textColor } =
      data || {};
    return (
      <div class="relative flex items-center bg-white rounded-lg shadow-100 mb-4">
        <div className={`absolute top-[-5px] right-0
          ${award?.includes("Golden Nose") ? "bg-light-400 text-gray-900" : "bg-purple-600 text-white"}  
          text-xs font-semibold py-1 px-3 rounded-full`}
        >
          {award}
        </div>
        <div class="flex items-center p-6 w-100">
          <div class="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mr-4">
            <img src={dogImage?.length > 0 ? dogImage : dogImg} alt="Dog Icon" class="w-14 h-14 object-cover rounded-full" />
          </div>
          <div>
            <div class="text-lg font-bold text-gray-800">Dog: {dog}</div>
            <div class="text-sm text-gray-600">Breed: {breed}</div>
            <div class="text-sm text-gray-600">Handler: {handler}</div>
          </div>
        </div>
      </div>   
    );
  };


  const renderPremierCard = () => {
    const sortedResults = [...premierPlacementResults].sort((a, b) => 
      a.title.localeCompare(b.title, undefined, { numeric: true })
    );
    return (
      <>
        <p className="font-semibold text-gray-900 text-xl lg:ml-0">
          Premier Overall Placements
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 text-wrap gap-3 my-4">
          {sortedResults.map((dog, index) => (
              <div  key={index} className="relative flex items-center bg-white rounded-lg shadow-100">
                <div
                  className={`absolute top-[-5px] right-0 ${dog.title.includes("1")
                      ? "bg-blue text-white"
                      : dog.title.includes("2")
                      ? "bg-red text-white"
                      : "bg-light-400"
                    } text-xs font-semibold py-1 px-3 rounded-full`}
                >
                  {dog.title.includes("1") ? "1st" : dog.title.includes("2") ? "2nd" : "3rd"}
                </div>
                <div className="flex items-center p-6 w-full">
                  <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                    <img
                      src={dogImg}
                      alt="Dog Icon"
                      className="w-14 h-14 object-cover rounded-full"
                    />
                  </div>
                  <div>
                    <div className="text-lg font-bold text-gray-800">
                      Dog: {getValue(dog.values[0]?.dog) || 'Not available'}
                    </div>
                    <div className="text-sm text-gray-600">
                      Breed: {getValue(dog.values[0]?.breed) || 'Not available'}
                    </div>
                    <div className="text-sm text-gray-600">
                      Handler: {getValue(dog.values[0]?.handler) || 'Not available'}
                    </div>
                  </div>
                </div>
              </div> 
          ))}
           </div>
      </>
    );
};

  if (loading) {
    return (
      <div className={`App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10`}>
        <PageInfo title="Trial Result Details" onClick={() => navigate(-1)} />
        <div className="h-[70vh] flex justify-center items-center text-center mt-4">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <ScrollToTop />
      <PageInfo 
        onClick={() => {
          setTrial?.(null);
          navigate(-1);
        }}
        title={!isMember
        ? "Upload Trial Result Details"
        : "Trial Result Details"}
      />
      <div className="border rounded-md shadow-100 bg-white p-6 my-6">
        <div
          className={`flex ${isMobile ? "flex-col" : "flex-row"
            } justify-between`}
        >
          <div className="flex flex-col">
            <span className="font-medium text-gray-700 text-sm">
              Trial Name
            </span>
            <span className="font-semibold text-gray-900 text-lg">
              {trail?.trialName}
            </span>
          </div>
          <div className="flex flex-col lg:w-[516px] md:w-[332px] lg:mt-0 md:mt-0 mt-4">
          <span className="font-medium text-gray-700 text-sm">
              Trial Date
            </span>
            <span className="font-semibold text-gray-900 text-lg">
              {moment.utc(trail?.trialDate).format("MMMM DD, YYYY")}
            </span>
          </div>
        </div>
        <div
          className={`flex ${isMobile ? "flex-col" : "flex-row"
            } justify-between mt-4`}
        >
          <div className="flex flex-col">
            <span className="font-medium text-gray-700 text-sm">Host</span>
            <span className="font-semibold text-gray-900 text-lg">
              {host?.hostName}
            </span>
          </div>
          <div className="flex flex-col lg:w-[516px] lg:mt-0 md:mt-0 mt-4">
          <span className="font-medium text-gray-700 text-sm">Location</span>
            <span className="font-semibold text-gray-900 text-lg">
              {trail?.city}, {trail?.state}
            </span>
          </div>
        </div>
      </div>
      <span className="font-semibold text-gray-900 text-2xl lg:ml-0 ml-4">
        Awards
      </span>
      {sortedAwards?.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 text-wrap gap-3 mt-5">
          {sortedAwards?.map((dog) => renderCard(dog))}
        </div>
      ) : (
        <div className="items-center justify-center flex flex-row h-[100px] w-full">
          <span className="text-black font-medium text-base">
            No Awards Found
          </span>
        </div>
      )}
 
      {premierPlacementResults?.length > 0 && (
        <>
            {renderPremierCard()}
        </>
      )}
      <div className="flex flex-row justify-between mt-6 lg:mr-8 md:mr-6 md:ml-6 mx-4 lg:mx-0 items-center mb-4">
        <span className="font-semibold text-gray-900 text-2xl">Results</span>
        <div className={`z-50 ${tableResult?.length <= 0 && "hidden"}`}>
          <MultiSelectWithSearch
            options={noPlacementDropdowns?.map(
              (e, ind) => ({
                id: ind + 1,
                label: e,
              })
            )}
            placeholder={"All Elements"}
            width={isMobile ? "w-[178px]" : "w-[320px]"}
            isMultiSelect
            closeOnSelect={true}
            onChange={(option) => {
              setTableResult([]);
              setSelectedElements(option?.map((e) => e?.label));
            }}
            onClear={() => {
              setTableResult([]);
              setSelectedElements([]);
            }}
          />
        </div>
      </div>
      {resultLoading ? (
        <Loader />
      ) : noPlacementResults?.length > 0 ? (
        orderSearchesElements(noPlacementResults, "title")?.map((e) => {
          return (
            <div className="mb-8">
              <Table
                title={e?.title}
                headData={e?.tableHeading}
                tableBody={
                  e?.title?.includes("SIT")
                    ? renderTableBodyForSIT(e?.values)
                    : renderTableBody(e?.values)
                }
              />
            </div>
          );
        })
      ) : (
        <div className="items-center justify-center flex flex-row h-[100px] w-full">
          <span className="text-black font-medium text-base">
            No Results Found
          </span>
        </div>
      )}
    </div>
  );
};

export default TrialResultDetails;
